import TENANTS from '~/consts/tenant';

import type { BrandSchedule, CampaignScheduleBrandRow, CampaignSchedulePillType } from './types';

export function getBrandDisplayName(brand: string): string {
  return Object.values(TENANTS).find((tenant) => tenant.brand === brand)?.title ?? brand;
}

function pickPrimarySchedule(schedules: Array<BrandSchedule>): BrandSchedule {
  return (
    schedules.find((schedule) => schedule.type === 'online_purchase') ??
    schedules.find((schedule) => schedule.type === 'availability') ??
    schedules.find((schedule) => schedule.type === 'list_visibility') ??
    schedules[0]
  );
}

function getPill(primary: BrandSchedule, isLuxPlus: boolean): CampaignSchedulePillType {
  if (isLuxPlus) {
    return 'lux_plus';
  }

  if (primary.type === 'online_purchase') {
    return 'available_offline';
  }

  return null;
}

export function buildCampaignScheduleBrandRows(brandSchedules: Array<BrandSchedule>): Array<CampaignScheduleBrandRow> {
  const groups = new Map<string, Array<BrandSchedule>>();

  brandSchedules.forEach((schedule) => {
    const isLuxPlus = schedule.type === 'lux_plus';
    const key = `${schedule.brand}-${isLuxPlus ? 'lux_plus' : 'standard'}`;
    const existing = groups.get(key);

    if (existing) {
      existing.push(schedule);
    } else {
      groups.set(key, [schedule]);
    }
  });

  return Array.from(groups.entries()).map(([key, schedules]) => {
    const isLuxPlus = schedules[0].type === 'lux_plus';
    const primary = pickPrimarySchedule(schedules);
    const regions = Array.from(new Set(schedules.map((schedule) => schedule.region)));

    const brandName = getBrandDisplayName(schedules[0].brand);

    return {
      key,
      brand: isLuxPlus ? `${brandName} - LuxPlus` : brandName,
      isLuxPlus,
      start: primary.start,
      end: primary.end,
      pill: getPill(primary, isLuxPlus),
      regions,
    };
  });
}
